import { AlertDTO } from '@meshwatch/types';
import { SQS } from 'aws-sdk/clients/all';

import { SQSQueue, DEFAULT_SQS_CLIENT } from '../shared/aws/sqs';

class AlertViolationNotifier {
  private readonly QUEUE_NAME = 'alert-notification';
  private readonly queue: SQSQueue;

  public constructor(sqsClient: SQS = DEFAULT_SQS_CLIENT) {
    this.queue = new SQSQueue(this.QUEUE_NAME, sqsClient);
  }

  public process = (alert: AlertDTO) => {
    const MessageBody = JSON.stringify(alert);
    return this.queue.sendMessage({
      MessageBody,
      MessageAttributes: {
        Timestamp: { DataType: 'String', StringValue: new Date().toISOString() },
      },
    });
  };
}

export default AlertViolationNotifier;
